module.exports = __webpack_public_path__ + "static/media/mastercard-debitCard.3b168ec9.svg";